export default {"src":"/_next/static/media/hivesigner.58e8f2be.svg","height":131,"width":110,"blurWidth":0,"blurHeight":0};